// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 328 ? "a697e47d" : chunkId) + "." + {"328":"49d12e4294e768cf7736","539":"fcc1f3e58763f6b24688"}[chunkId] + ".js";
};